module.exports = __webpack_public_path__ + "static/media/background.fc10e212.jpg";